/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var FormatGroupTextEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(FormatGroupTextEventArgs, _super);
    function FormatGroupTextEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.d = null;
        _this.a = null;
        _this.c = null;
        _this.b = null;
        return _this;
    }
    FormatGroupTextEventArgs.$t = markType(FormatGroupTextEventArgs, 'FormatGroupTextEventArgs');
    return FormatGroupTextEventArgs;
}(Base));
export { FormatGroupTextEventArgs };
//# sourceMappingURL=FormatGroupTextEventArgs.js.map
